import { render, staticRenderFns } from "./AddBonus.vue?vue&type=template&id=e19bac26"
import script from "./AddBonus.vue?vue&type=script&lang=js"
export * from "./AddBonus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports